import { electricPurple500, robotoRegular } from '@habitech/shared';
import styled from 'styled-components';

export const AccessoryAreasSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-family: ${robotoRegular};
  font-size: 14px;
`;

export const AccessoryAreasHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;

  .section-title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #212529;
  }
`;

export const AddAreaButton = styled.button`
  border: 1px solid ${electricPurple500};
  background: #fff;
  color: ${electricPurple500};
  border-radius: 0.375rem;
  padding: 0.25rem 0.75rem;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition:
    background-color 0.15s ease-in-out,
    color 0.15s ease-in-out;

  &:hover {
    background: ${electricPurple500};
    color: #fff;
  }
`;

export const AccessoryAreaCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.75rem;
  background: #fafafa;
`;

export const AccessoryAreaCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .area-index {
    font-size: 13px;
    font-weight: 600;
    color: #495057;
  }
`;

export const RemoveAreaButton = styled.button`
  border: none;
  background: transparent;
  color: #dc3545;
  font-size: 13px;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #bb2d3b;
  }
`;

export const EmptyState = styled.p`
  margin: 0;
  font-size: 13px;
  color: #6c757d;
`;
